//import * as React from 'react'
import { clienteAxiosOctagon, clienteAxiosSaasExternalConector } from "../axios";
import { sendMailWithSaas } from "../MailRequest"

export const jsonDeserialize = (objJSON) => {
    return JSON.parse(objJSON);
}

export const getEstados = () => {
    return new Promise((resolve, reject) => {

        try {
            //Hacemos la peticion a la api

            const respuesta = clienteAxiosOctagon({
                method: 'get',
                url: "/octagon/estados/",
                headers: {
                    "Authorization": process.env.REACT_APP_OCTAGON_AUTH_TOKEN,
                    "Auth": "",
                    "bypass": true
                }
            })

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Estados");
        }
    });
}


export const getConcesionarios = () => {
    return new Promise((resolve, reject) => {

        try {
            //Hacemos la peticion a la api

            const respuesta = clienteAxiosOctagon({
                method: 'post',
                url: "/octagon/dealers/dealer/listAll",
                headers: {
                    "Authorization": process.env.REACT_APP_OCTAGON_AUTH_TOKEN,
                    "bypass": true,
                    "Content-Type": "application/json"
                },
                data: {
                    "brandId": 4,
                    "enabled": true
                }
            })

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Concesionarios");
        }
    });
}

export const getHorarios = (uuid, fechaInicial, fechaFinal, tipoServicio, idConcesionario) => {
    return new Promise((resolve, reject) => {

        try {
            //Hacemos la peticion a la api
            const respuesta = clienteAxiosSaasExternalConector({
                method: 'get',
                url: `/audi/citas/get/horarios/${uuid}/${fechaInicial}/${fechaFinal}/${tipoServicio}/${idConcesionario}`
            })

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Consultar");
        }
    });
}

export const solicitarCita = (stateData) => {
    return new Promise((resolve, reject) => {

        try {
            //Hacemos la peticion a la api
            const respuesta = clienteAxiosSaasExternalConector({
                method: 'post',
                url: "/audi/citas/request/appointment",
                data: {
                    "uuid": stateData.uuid,
                    "nombre": stateData.nombre.trim(),
                    "apePat": stateData.apellidoPaterno.trim(),
                    "apeMat": stateData.apellidoMaterno.trim(),
                    "numeroChasis": stateData.numeroChasis,
                    "numeroSerie": "",
                    "fecha": stateData.fechaCita,
                    "horario": stateData.horarioCita,
                    "asesor": "",
                    "telefonoFijo": "",
                    "telefonoMovil": stateData.telefono.trim(),
                    "email": stateData.correo.trim(),
                    "estado": stateData.estado,
                    "ciudad": "",
                    "fechaUltimoServicio": "",
                    "idConcesionario": stateData.idConcesionario,
                    "marca": "AUDI",
                    "modelo": stateData.modeloAuto,
                    "anio": stateData.yearModelo,
                    "kilometrajeAuto": "",
                    "kilometrajeServicio": "",
                    "tipoServicio": stateData.servicio,
                    "comentarios": stateData.comentarios.trim()
                }
            })

            resolve(respuesta);

            /*resolve({
                "data" :{
                    "data":{
                        "idCita" : "123456789"
                    }
                }
            });*/
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Agendar");
        }
    });
}

export const cancelarCita = (uuid, idCita, idConcesionario) => {
    return new Promise((resolve, reject) => {

        try {
            //Hacemos la peticion a la api

            const respuesta = clienteAxiosSaasExternalConector({
                method: 'delete',
                url: "/audi/citas/cancel/appointment",
                data: {
                    "uuid": uuid,
                    "idCita": idCita,
                    "idConcesionario": idConcesionario
                }
            })

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Cancelar");
        }
    });
}

export const sendMailConCita = (stateData, numeroCita) => {
    const encodedMail = encodeURI(stateData.correo.trim());
    const encodedCliente = encodeURI((stateData.nombre.trim() + " " + stateData.apellidoPaterno.trim()));
    const urlAvisoDePrivacidad = stateData.dealerUrls.length === 0 ? process.env.REACT_APP_AVISO_PRIVACIDAD : stateData.dealerUrls[1];

    const urlCancelar = process.env.REACT_APP_DOMAIN + "/audi-forms/citas-de-servicio/cancelar/" + numeroCita + "/" + stateData.idConcesionario + "/" + stateData.uuid + "/" + encodedMail + "/" + encodedCliente
    return new Promise((resolve, reject) => {

        try {
            const respuesta = sendMailWithSaas({

                "source": `${process.env.REACT_APP_CITAS_SERVICIO_CORREO_PERSONAL} <${process.env.REACT_APP_CITAS_SERVICIO_CORREO_FROM}>`,
                "subject": process.env.REACT_APP_CITAS_SERVICIO_CORREO_CON_CITA_ASUNTO,
                "to": [stateData.correo.trim()],
                "cc": stateData.correoContacto,
                "bcc": [process.env.REACT_APP_CITAS_SERVICIO_CORREO_CCO_ICDC],
                "html": `<!DOCTYPE html>
                <html lang='es-MX'>
                    <head>
                        <meta charset='utf-8' http-equiv='Content-Type' content='text/html' />
                        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                        <title>Citas de Servicio</title>
                    </head>
                    <body style='margin: 0; padding: 0;'>
                        <table align='center' border='0' cellpadding='0' cellspacing='0' width='600' style='border-collapse: collapse;box-shadow: 0px 20px 40px #00000029;' bgcolor='#ffffff'>
                            <tr>
                                <th width='20' ></th>
                                <th style='text-align:center;padding-top:24px;padding-bottom:24px;padding-left: 245px;'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/logo_audi.png' width='76' style='display: block;' alt='Audi Logo'>
                                </th>
                                <th width='20' ></th>
                            </tr>
                            <tr bgcolor='#000000'>
                                <td style='text-align: center;' colspan='3'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/formsSalesforce/citas-servicio2x.jpg' width='600' alt='Audi Header' style='display: block;'>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align:left;padding-top:60px;padding-bottom:30px;font-size:20px;font-weight: bold;font-family:AudiType,sans-serif;'>
                                    ¡Hola!
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align: left;padding-bottom:30px;font-size: 16px;font-family: AudiType,sans-serif;font-weight: normal;font-stretch:105%;line-height: 24px;font-stretch:130%'>
                                    Tu cita ha sido reservada, para confirmarla, un asesor se contactará contigo en breve.<br/><br/>
                                    ID de cita: <b>` + numeroCita + `</b> <br/>
                                    Cliente: ` + stateData.nombre.trim() + ` ` + stateData.apellidoPaterno.trim() + ` <br/>
                                    Teléfono: ` + stateData.telefono.trim() + ` <br/>
                                    Correo: ` + stateData.correo.trim() + ` <br/>
                                    Concesionaria: ` + stateData.concesionario + ` <br/>
                                    Fecha: ` + stateData.fechaCita + ` <br/>
                                    Hora: ` + stateData.horarioCita + ` <br/>
                                    Servicio: ` + stateData.servicio + `
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align:center;padding-bottom:55px;font-size:20px;font-weight: bold;font-family:AudiType,sans-serif;font-stretch:130%'>
                                    ¡Gracias por tu preferencia!
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td align='left' style='color:#757575;border-top-width: 1px;border-top-style:solid;border-top-color: #B9B7B5;text-align:left;padding-top: 20px;padding-bottom: 72px;font-size:12px;font-weight: normal;line-height: 23px;font-family: AudiTypeWide,sans-serif;'>
                                    <font>
                                        Este mensaje se envió a <a href='mailto:` + stateData.correo.trim() + `' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>` + stateData.correo.trim() + `</a> <br/>
                                        <a href='${urlCancelar}' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;' >Cancelar mi cita</a> | <a href='` + urlAvisoDePrivacidad + `' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;' >Política de Privacidad</a>
                                    </font>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </body>
                </html>`
            });

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Correo " + error);
        }
    });
}

export const sendMailSinCita = (stateData) => {
    const urlAvisoDePrivacidad = stateData.dealerUrls.length === 0 ? process.env.REACT_APP_AVISO_PRIVACIDAD : stateData.dealerUrls[1];
    return new Promise((resolve, reject) => {

        try {
            const respuesta = sendMailWithSaas({

                "source": `${process.env.REACT_APP_CITAS_SERVICIO_CORREO_PERSONAL} <${process.env.REACT_APP_CITAS_SERVICIO_CORREO_FROM}>`,
                "subject": process.env.REACT_APP_CITAS_SERVICIO_CORREO_SIN_CITA_ASUNTO,
                "to": [stateData.correo.trim()],
                "cc": stateData.correoContacto,
                "bcc": [process.env.REACT_APP_CITAS_SERVICIO_CORREO_CCO_ICDC],
                "html": `<!DOCTYPE html>
                    <html lang='es-MX'>
                    <head>
                        <meta charset='utf-8' http-equiv='Content-Type' content='text/html' />
                        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                        <title>Citas de Servicio</title>
                    </head>
                    <body style='margin: 0; padding: 0;'>
                        <table align='center' border='0' cellpadding='0' cellspacing='0' width='600' style='border-collapse: collapse;box-shadow: 0px 20px 40px #00000029;' bgcolor='#ffffff'>
                            <tr>
                                <th width='20' ></th>
                                <th style='text-align:center;padding-top:24px;padding-bottom:24px;padding-left: 245px;'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/logo_audi.png' width='76' style='display: block;' alt='Audi Logo'>
                                </th>
                                <th width='20' ></th>
                            </tr>
                            <tr bgcolor='#000000'>
                                <td style='text-align: center;' colspan='3'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/formsSalesforce/citas-servicio2x.jpg' width='600' alt='Audi Header' style='display: block;'>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align:left;padding-top:60px;padding-bottom:30px;font-size:20px;font-weight: bold;font-family:AudiType,sans-serif;'>
                                    ¡Hola!
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align: left;padding-bottom:30px;font-size: 16px;font-family: AudiType,sans-serif;font-weight: normal;font-stretch:105%;line-height: 24px;font-stretch:130%'>
                                    Tu cita ha sido reservada, para confirmarla, un asesor se contactará contigo en breve.<br/><br/>
                                    Cliente: ` + stateData.nombre.trim() + ` ` + stateData.apellidoPaterno.trim() + ` <br/>
                                    Teléfono: ` + stateData.telefono.trim() + ` <br/>
                                    Correo: ` + stateData.correo.trim() + ` <br/>
                                    Concesionaria: ` + stateData.concesionario + ` <br/>
                                    Fecha: ` + stateData.fechaCita + ` <br/>
                                    <strong>Hora: ` + stateData.horarioCita + ` </strong> <br/>
                                    Servicio: ` + stateData.servicio + `
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td style='text-align:center;padding-bottom:55px;font-size:20px;font-weight: bold;font-family:AudiType,sans-serif;font-stretch:130%'>
                                    ¡Gracias por tu preferencia!
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td align='left' style='color:#757575;border-top-width: 1px;border-top-style:solid;border-top-color: #B9B7B5;text-align:left;padding-top: 20px;padding-bottom: 72px;font-size:12px;font-weight: normal;line-height: 23px;font-family: AudiTypeWide,sans-serif;'>
                                    <font>
                                        Este mensaje se envió a <a href='mailto:` + stateData.correo.trim() + `' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>` + stateData.correo.trim() + `</a> <br/>
                                        <a href='`+ urlAvisoDePrivacidad + `' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;' >Política de Privacidad</a>
                    
                                    </font>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </body>
                    </html>`,
            })

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Correo " + error);
        }
    });
}
export const sendMailDealer = (stateData) => {
    const urlAvisoDePrivacidad = stateData.dealerUrls.length === 0 ? process.env.REACT_APP_AVISO_PRIVACIDAD : stateData.dealerUrls[1];
    return new Promise((resolve, reject) => {

        try {
            const respuesta = sendMailWithSaas({

                "source": `${process.env.REACT_APP_CITAS_SERVICIO_CORREO_PERSONAL} <${process.env.REACT_APP_CITAS_SERVICIO_CORREO_FROM}>`,
                "subject": process.env.REACT_APP_CITAS_SERVICIO_CORREO_DMS_ERROR_ASUNTO,
                "to": [stateData.correoContacto[0]],
                "cc": stateData.correoContacto.length === 1 ? [] : stateData.correoContacto,
                "bcc": [process.env.REACT_APP_CITAS_SERVICIO_CORREO_CCO_ICDC],
                "html": `<!DOCTYPE html>
                    <html lang='es-MX'>
                    
                    <head>
                        <meta charset='utf-8' http-equiv='Content-Type' content='text/html' />
                        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                        <title>Aviso de desconexión DMS</title>
                    </head>
                    
                    <body style='margin: 0; padding: 0;'>
                        <table align='center' border='0' cellpadding='0' cellspacing='0' width='600' style='border-collapse: collapse;box-shadow: 0px 20px 40px #00000029;' bgcolor='#ffffff'>
                            <tr>
                                <th width='20' ></th>
                                <th style='text-align:center;padding-top:24px;padding-bottom:24px;padding-left: 245px;'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/logo_audi.png' width='76' style='display: block;' alt='Audi Logo'>
                                </th>
                                <th width='20' ></th>
                            </tr>
                    
                            <tr bgcolor='#000000'>
                                <td style='text-align: center;' colspan='3'>
                                    <div style="width: 100%; background-color: #FF0000;color:#fff;font-family:AudiType,sans-serif;font-size:30px;padding: 80px 0 ;">
                                        Aviso de desconexión
                                    </div>
                                </td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td style='text-align:left;padding-top:60px;padding-bottom:30px;font-size:16px;font-weight: bold;font-family:AudiType,sans-serif;color: #FF0000;'>
                                    Te informamos que tu servicio DMS se encuentra con una desconexión.
                                </td>
                                <td></td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td style='text-align: left;padding-bottom:30px;font-size: 16px;font-family: AudiType,sans-serif;font-weight: normal;font-stretch:105%;line-height: 24px;font-stretch:130%'>
                                    Debido a esto, la siguiente cita se ha agendado fuera de los horarios y fechas del DMS,<br/><br/>
                                    Cliente: ` + stateData.nombre.trim() + ` ` + stateData.apellidoPaterno.trim() + ` <br/>
                                    Teléfono: ` + stateData.telefono.trim() + ` <br/>
                                    Correo: ` + stateData.correo.trim() + ` <br/>
                                    Fecha: ` + stateData.fechaCita + ` <br/>
                                    Hora: ` + stateData.horarioCita + ` <br/>
                                    Servicio de interés: ` + stateData.servicio + ` <br/><br/>
                    
                                    Te recomendamos hacer un diagnóstico en tu DMS e ingresar tu cita en el mismo.
                                </td>
                                <td></td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td align='left' style='color:#757575;border-top-width: 1px;border-top-style:solid;border-top-color: #B9B7B5;text-align:left;padding-top: 20px;padding-bottom: 72px;font-size:12px;font-weight: normal;line-height: 23px;font-family: AudiTypeWide,sans-serif;'>
                                    <font>
                                        Este mensaje se envió a <a href='mailto:` + stateData.correo.trim() + `' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>` + stateData.correo.trim() + `</a> <br/>
                                        <a href='`+ urlAvisoDePrivacidad + `' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;' >Política de Privacidad</a>
                    
                                    </font>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </body>
                    
                    </html>`
            }
            )

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Correo " + error);
        }
    });
}

export const sendMailDealerCancelar = (stateData) => {
    const decodedCliente = decodeURI(stateData.cliente.trim());
    const decodedMail = decodeURI(stateData.correo.trim());
    const urlAvisoDePrivacidad = stateData.dealerUrls.length === 0 ? process.env.REACT_APP_AVISO_PRIVACIDAD : stateData.dealerUrls[1];

    return new Promise((resolve, reject) => {

        try {
            const respuesta = sendMailWithSaas({
                "source": `${process.env.REACT_APP_CITAS_SERVICIO_CORREO_PERSONAL} <${process.env.REACT_APP_CITAS_SERVICIO_CORREO_FROM}>`,
                "subject": process.env.REACT_APP_CITAS_SERVICIO_CORREO_DMS_ERROR_ASUNTO,
                "to": [stateData.correoContacto[0]],
                "cc": stateData.correoContacto.length === 1 ? [] : stateData.correoContacto,
                "bcc": [process.env.REACT_APP_CITAS_SERVICIO_CORREO_CCO_ICDC],
                "html": `<!DOCTYPE html>
                    <html lang='es-MX'>
                    
                    <head>
                        <meta charset='utf-8' http-equiv='Content-Type' content='text/html' />
                        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                        <title>Aviso de desconexión DMS</title>
                    </head>
                    
                    <body style='margin: 0; padding: 0;'>
                        <table align='center' border='0' cellpadding='0' cellspacing='0' width='600' style='border-collapse: collapse;box-shadow: 0px 20px 40px #00000029;' bgcolor='#ffffff'>
                            <tr>
                                <th width='20' ></th>
                                <th style='text-align:center;padding-top:24px;padding-bottom:24px;padding-left: 245px;'>
                                    <img src='https://www.appsaudi.com.mx/resources/images/logo_audi.png' width='76' style='display: block;' alt='Audi Logo'>
                                </th>
                                <th width='20' ></th>
                            </tr>
                    
                            <tr bgcolor='#000000'>
                                <td style='text-align: center;' colspan='3'>
                                    <div style="width: 100%; background-color: #FF0000;color:#fff;font-family:AudiType,sans-serif;font-size:30px;padding: 80px 0 ;">
                                        Intento de cancelación fallido
                                    </div>
                                </td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td style='text-align:left;padding-top:60px;padding-bottom:30px;font-size:16px;font-weight: bold;font-family:AudiType,sans-serif;color: #FF0000;'>
                                    Se realizo un intento de cancelación de cita de servicio con los siguientes datos:
                                </td>
                                <td></td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td style='text-align: left;padding-bottom:30px;font-size: 16px;font-family: AudiType,sans-serif;font-weight: normal;font-stretch:105%;line-height: 24px;font-stretch:130%'>
                                    Cliente: ` + decodedCliente + ` <br/>
                                    Correo: ` + decodedMail + ` <br/>
                                    Uuid: ` + stateData.uuid + ` <br/>
                                    Id de cita:  ` + stateData.idcita + ` <br/>
                                    Id de concesionario:  ` + stateData.idconcesionaria + ` <br/><br/>
                    
                                    Te recomendamos hacer un diagnóstico en tu DMS y ponerte en contacto con el cliente.
                                </td>
                                <td></td>
                            </tr>
                    
                            <tr>
                                <td></td>
                                <td align='left' style='color:#757575;border-top-width: 1px;border-top-style:solid;border-top-color: #B9B7B5;text-align:left;padding-top: 20px;padding-bottom: 72px;font-size:12px;font-weight: normal;line-height: 23px;font-family: AudiTypeWide,sans-serif;'>
                                    <font>
                                        Este mensaje se envió a <a href='mailto:` + stateData.correo.trim() + `' target='_blank' style='color: #000000;text-decoration: none;font-weight: bold;'>` + stateData.correo.trim() + `</a> <br/>
                                        <a href='`+ urlAvisoDePrivacidad + `' target='_blank' style='color: #000000;text-decoration: none;border-bottom-color: #000000;border-bottom-width: 1px; border-bottom-style: solid;' >Política de Privacidad</a>
                    
                                    </font>
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </body>
                    
                    </html>`
            }
            )

            resolve(respuesta);
        } catch (error) {
            //Si existe un error
            reject("Error en petición a API - Correo " + error);
        }
    });
}





export const encodeNumber = (idNumber) => {
    var hexString = parseInt(idNumber).toString(16);
    return hexString;
}
export const decodeToNumber = (hexString) => {
    var idNumber = parseInt(hexString, 16);
    return idNumber.toString();
}